import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Box,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import axios from 'axios';

import { useManualCache } from '../../hooks/useManualCache';
import theme from '../../themes/theme';

import DynamicIcon from './DynamicIcon';
export default function AktivuDropzone(props) {
  const Item = styled(Paper)(({ theme }) => ({
    fontSize: 10,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.white.main,
    backgroundColor: theme.palette.success.main,
  }));

  const [updateCache] = useManualCache();

  const { title, upload_type, prefix, showTitle } = props;
  const [progress, setProgress] = useState({ percent: 0 });
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.png', '.jpg', '.gif'],
      'application/pdf': ['.pdf'],
      'text/csv': ['.csv'],
      'text/text': ['.txt'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        ['.docx'],
      'application/vnd.ms-excel': ['.xlsx', 'xls'],
      'video/mp4': ['.mp4'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        ['.xlsx'],
    },
    maxFiles: 100,
    onDrop: async files => {
      if (props?.dropzonePreview) {
        props?.handleDropEmit({ dropFile: true });
      }
      // eslint-disable-next-line array-callback-return
      // using axios for the file uploads to track upload progress. fetch api does not support progress yet!
      files.map(async f => {
        // get presigned url
        const payload = {
          upload_type,
          key: `${prefix}/${f.name}`,
        };

        const response = await axios.post(
          '/api/s3/presigned-url',
          payload
        );

        const { url } = await response.data;

        // upload using presigned url
        if (url) {
          await axios.put(url, f, {
            onUploadProgress: progressEvent => {
              const percent = parseInt(
                (progressEvent.loaded / progressEvent.total) * 100
              );

              if (percent >= 100) {
                setProgress({ percent: 100 });
                props.handleProcessBtnEmit({
                  fileName: payload.key,
                  success: true,
                });
              } else {
                setProgress({ percent });
              }
            },
          });
          updateCache(['s3Files']);
        }
      });
    },
  });

  // TODO: convert to grid.👇
  const xfiles = acceptedFiles.map(file => (
    <Item key={file.path}>
      {file.path}
      <br />
      {(file.size / (1024 * 1024)).toFixed(2)}MB
    </Item>
  ));

  return (
    <>
      {showTitle && (
        <Typography variant={'h6'}>
          {title || 'Upload Files'}
        </Typography>
      )}
      <Typography
        component={'span'}
        sx={{
          border: 1,
          borderColor: '#ccc',
          p: 10,
          backgroundColor: theme.palette.body_bg.main,
        }}
        {...getRootProps({ className: 'dropzone' })}
      >
        <input {...getInputProps()} />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DynamicIcon
            iconName={'CloudUpload'}
            style={{
              verticalAlign: 'middle',
              marginRight: 5,
            }}
          ></DynamicIcon>
          Drag 'n' drop some files here, or click to select files
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress
              variant="determinate"
              value={progress.percent}
            />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography
              variant="body2"
              color="text.secondary"
            >{`${Math.round(progress.percent)}%`}</Typography>
          </Box>
        </Box>
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Stack direction="row" spacing={1}>
          {xfiles}
        </Stack>
      </Box>
    </>
  );
}
